import './tooltip.scss';

import React from 'react';
import { Tooltip as ReactStrapTooltip } from 'reactstrap';

export default class Tooltip extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
    };
  }

  toggle() {
    const { tooltipOpen } = this.state;
    this.setState({
      tooltipOpen: !tooltipOpen,
    });
  }

  render() {
    return (
      <ReactStrapTooltip
        boundariesElement="window"
        {...this.props}
        isOpen={this.state.tooltipOpen}
        toggle={this.toggle}
      >
        {this.props.children}
      </ReactStrapTooltip>
    );
  }
}

Tooltip.propTypes = ReactStrapTooltip.propTypes;
